export const ESTATE_NOT_FOUND_CONTACT = 'https://www.maanmittauslaitos.fi/huoneistot-ja-kiinteistot/huoneistojen-ja-kiinteistojen-palvelut/selvita-kiinteistotunnus';
export const ESTATE_VALUE_FACTOR = 0.95;
